import React from "react";
import { cn } from "@gettactic/helpers";
import { useFormControlWrapper } from "../FormControlWrapper/FormControlWrapperProvider";

export interface TextareaInputProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputClassName?: string;
  disableOutline?: boolean;
}

const disabledCssClasses = "cursor-not-allowed opacity-50";

export const TextareaInput = React.forwardRef<
  HTMLTextAreaElement,
  TextareaInputProps
>((props, ref) => {
  const { inputClassName, className, disableOutline, ...rest } = props;
  const { id, isDisabled } = useFormControlWrapper();

  return (
    <textarea
      {...rest}
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        isDisabled && disabledCssClasses,
        disableOutline && "outline-none ring-0",
        className,
        inputClassName
      )}
      ref={ref}
      id={id}
    />
  );
});

TextareaInput.displayName = "TextareaInput";
